export default {
  setPedidos(state, p) {
    state.pedidos = p;
  },
  setTotalPedidos(state, n) {
    state.totalPedidos = n;
  },
  setCategorias(state, c) {
    state.categorias = c;
  },
  setProductos(state, p) {
    state.productos = p;
  }
}